



const SectionTitle = ({ title, className }) => {
    return <h2 className={`${className} text-center mt-2 mb-12 bold text-2xl`}> 
        { title }
    </h2>
};

export default SectionTitle;